import { render, staticRenderFns } from "./main.vue?vue&type=template&id=eeaa7b06&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeaa7b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eeaa7b06')) {
      api.createRecord('eeaa7b06', component.options)
    } else {
      api.reload('eeaa7b06', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=eeaa7b06&scoped=true", function () {
      api.rerender('eeaa7b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Video/main.vue"
export default component.exports